import { retirementOfPeriodRequest as schemaRetirementOfPeriodRequest } from './schemas';
import apiClient from './apiClient';
import RetirementOfPeriodRequestDataStore from '../../datastores/RetirementOfPeriodRequestDataStore';

class RetirementOfPeriodRequestDataStoreGraphQL
  implements RetirementOfPeriodRequestDataStore
{
  client = apiClient();

  async register({
    procedureId,
    reason,
    detail,
    contact,
    idDetail2,
    detail2,
    period,
    career
  }: {
    procedureId: number;
    reason: string;
    detail: string;
    contact: string;
    idDetail2: number;
    detail2: string;
    period: string;
    career?: string;
  }) {
    try {
      const response = await this.client.mutate({
        mutation:
          schemaRetirementOfPeriodRequest.registerRemoveFromPeriodRequestProcedure,
        variables: {
          procedureId,
          reason,
          detail,
          contact,
          idDetail2,
          detail2,
          period,
          career
        }
      });
      const { data } = response;
      return data?.registerRemoveFromPeriodProcedure;
    } catch (error) {
      throw new Error('error register fields form');
    }
  }
}
export default RetirementOfPeriodRequestDataStoreGraphQL;
